import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/vi'
import 'dayjs/locale/en'

// Extend dayjs with plugins
dayjs.extend(relativeTime)
dayjs.extend(utc)

// Function to update dayjs locale
export const updateDayjsLocale = (language) => {
    dayjs.locale(language)
}

// Initialize with default locale
updateDayjsLocale('vi')

export default dayjs
